import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useMsal } from "@azure/msal-react"; // MSAL React hook
import { loginRequest } from "./msalConfig"; // MSAL config
import { callLoginUserFromMicrosoft } from "http/auth/login";
import CryptoJS from "crypto-js";
import {
    Row,
    Col,
    Form,
    Button,
} from "reactstrap";

// import your images
import lightlogo from "../../assets/images/cashinvoice-white-logo.svg";
import verificationImg from "../../assets/images/5024147-Photoroom.png";
import MicrosoftLogo from "../../assets/images/Microsoft_logo.svg";
import "assets/scss/custom/pages/_signup.scss";
import ToastDialog from "components/Common/ToastDialog";

const MicrosoftLogin = () => {
    const navigate = useNavigate();
    const { instance } = useMsal(); // Access MSAL instance
    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleLogin = () => {
        setIsSubmitting(true)
        instance
            .loginPopup(loginRequest)
            .then((response) => {
                callLoginUserFromMicrosoft({ email: response.account.username })
                    .then((result) => {
                        if (result.code == 200 && result.status) {
                            const { data, tokens, permissions } = result;
                            if (data.entityIsVerify == 1) {
                                data.EntityAssignedFlag = data.EntityAssignedFlag == 1

                                const passphrase = process.env.REACT_APP_KEY;
                                const encryptedUser = CryptoJS.AES.encrypt(
                                    JSON.stringify(data),
                                    passphrase
                                ).toString();
                                localStorage.setItem("user", encryptedUser)
                                localStorage.setItem("tokens", JSON.stringify(tokens));
                                localStorage.setItem("permissions", JSON.stringify(permissions));
                                const encryptedId = btoa(result.data.entityId.toString());

                                if (data.roleName === "fundLync_cutomer") {

                                    localStorage.setItem("encryptedId", JSON.stringify(encryptedId));
                                    navigate(
                                        `/customer/entity-dashboard?id=${encodeURIComponent(
                                            encryptedId
                                        )}`
                                    );
                                } else if (data.roleName == "financier_admin") {
                                    navigate(`/financier_admin/dashboard`);
                                } else if (data.roleName == "financier_operations") {
                                    navigate(`/financier_operations/dashboard`);
                                }
                                else {
                                    navigate(`/${data.roleName}/dashboard`);
                                }
                            }
                            setIsSubmitting(false)
                        } else {
                            setIsSubmitting(false)
                            const { message } = result;
                            setToastInfo({ message: message, showToast: true, role: "error" });
                        }
                    })
                    .catch((e) => {
                        setIsSubmitting(false)
                    })
                    .finally((f) => {
                        setIsSubmitting(false)
                    });
            })
            .catch((error) => {
                setIsSubmitting(false)
                console.error("Login failed:", error);
                setToastInfo({
                    showToast: true,
                    message: "Login failed. Please try again.",
                    role: "error",
                });
            });
    };

    return (
        <React.Fragment>
            <div className="account-pages account-pages-bg bg-color login-page">
                <Row
                    className="justify-content-center m-auto h-100vh scrollable-height"
                    style={{ width: "90%" }}
                >
                    <Col md={6} xl={8} lg={7} className="d-none d-md-block">
                        <div className="left-section h-100">
                            <img
                                src={lightlogo}
                                alt="Logo"
                                className="img-fluid ci-logo"
                                style={{ width: "200px" }}
                            />
                            <div className="d-flex justify-content-center w-100 h-100 align-items-center">
                                <img
                                    src={verificationImg}
                                    alt="Verification"
                                    className="img-fluid verification-img"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col
                        md={6}
                        lg={5}
                        xl={4}
                        className="form-layout-section m-auto d-flex justify-content-center"
                    >
                        <div className="p-2 mt-auto mb-auto">
                            <div className="d-flex flex-column align-items-center">
                                <h3 className="mt-3 mb-3 header-reg">Login with Microsoft</h3>
                            </div>
                            <div className="d-flex flex-column align-items-center">
                                Login to the portal using your Microsoft account or contact us if you face any issues.
                            </div>
                            <div className="d-flex justify-content-center mt-4 mb-2">
                                <div>
                                    <img src={MicrosoftLogo} alt="Microsoft logo" className="img-fluid" style={{ width: '60px', height: '50px' }} />
                                </div>
                                <div className="mt-1">
                                    <span className="fw-bold fs-2" style={{ color: '#808080' }}>Microsoft</span>
                                </div>

                            </div>
                            {/* <div className="d-flex justify-content-center fw-medium text-primary">Account</div> */}
                            <Form
                                className="needs-validation"
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    handleLogin()
                                }}
                            >

                                <div className="w-100 mt-3 d-flex justify-content-center">
                                    <Button color="primary" type="submit">
                                        {isSubmitting && (
                                            <span
                                                className="spinner-border spinner-border-sm ms-2 me-2"
                                                aria-hidden="true"
                                            ></span>
                                        )}
                                        {!isSubmitting && (
                                            <span>Login</span>
                                        )}
                                        {isSubmitting && (
                                            <span>Authenticating</span>
                                        )}
                                    </Button>
                                </div>
                                {/* <div className="mt-2 text-center">
                                    <p>
                                        Back to{" "}
                                        <Link to="/login" className="fw-medium text-primary">
                                            {" "}
                                            Login
                                        </Link>{" "}
                                    </p>
                                </div> */}
                            </Form>
                        </div>
                    </Col>
                </Row>
            </div>

            <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            />
        </React.Fragment>
    );
};

export default MicrosoftLogin;
